import { RemoteManifest, RemotesManifest } from 'types/federation';

export const getBranchNameFromHost = (): string | null => {
  const host = window.location.host;
  const parts = host.split('.');

  if (parts.length > 2) {
    return parts.slice(0, -2).join('.');
  }

  return null;
};

export const getManifestUrl = (): string => {
  const branchName = getBranchNameFromHost();
  // Checking if it's a custom branch environment
  if (branchName) {
    if(branchName.endsWith('-editor')) {
      // For editor branch, we need to use the remotes-manifest.json from staging.
      return `${window.location.origin}/-/remotes-manifest.json`;
    }

    const manifestName = branchName.replace('-app-shell', "");
    return `${window.location.origin}/-/${manifestName}-remotes-manifest.json`;
  }
  
  return `${process.env.HOST}/-/remotes-manifest.json`;
};

export const extractRoutesFromManifest = (manifest: RemotesManifest): Record<string, string> => {
  return manifest.remotes?.reduce((acc: Record<string, string>, remote: RemoteManifest) => {
    Object.values(remote.routes).forEach((route: string) => {
      acc[route] = remote.name;
    });
    return acc;
  }, {}) || {};
}; 

export const extractVersionsFromManifest = (manifest: RemotesManifest): Record<string, string> => {
  return manifest.remotes?.reduce((acc: Record<string, string>, remote: RemoteManifest) => {
    const version = remote.entry.split('/remoteEntry.js')[0].split('/').pop() || '';
    acc[remote.name] = version;
    return acc;
  }, {}) || {};
};
